const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
  const monthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const isLeapYear = year => year % 4 === 0;
  const getEmptyRows = () => {
    return Array.from({ length: 42 }).map(() => []);
  };
  const getMonthDays = (index, year) => {
    return index !== 1 ? monthDays[index] : isLeapYear(year) ? 29 : 28;
  };
  
  const getMonthStats = (monthIndex, year) => {
    const today = new Date(year, monthIndex, 1);
    const index = today.getMonth();
    return {
      name: index[index],
      days: getMonthDays(index, year)
    };
  };

export const getMonthName = index => monthNames[index];

export const getDayName = index => dayNames[index];

// Convert a date string in the format YYYY-MM-DD into a date string in the format DD/MM/YYYY
export const formatDate = (dateTime) => {
  if (dateTime && dateTime != "null") {
    let year = dateTime.substring(0,4);
    let month = dateTime.substring(5,7);
    let day = dateTime.substring(8,10);
    return day + "/" + month + "/" + year;
  }
  return null;
};

// Convert a date string in the format YYYY-MM-DDTHH:mm into a date string in the format DD/MM/YY at HH:mm
export const formatDateTime = (dateTime) => {
  if (dateTime && dateTime != "null") {
    let year = dateTime.substring(0,4);
    let month = dateTime.substring(5,7);
    let day = dateTime.substring(8,10);
    let time = dateTime.substring(11,16);
    return day + "/" + month + "/" + year + " at " + time;
  }
  return null;
};

// Convert a date string in the format YYYY-MM-DD into a Date object
export const getIsoDateStringAsDate = (dateString) => {
  if (dateString && dateString != "null") {
    let year = parseInt(dateString.substring(0,4));
    let month = parseInt(dateString.substring(5,7));
    let day = parseInt(dateString.substring(8,10));
    return new Date(year, (month -1), day);
  }
  return null;
}

// Convert a date string in the format DD/MM/YYYY into a date string in the format YYYY-MM-DD
export const getUkCalendarDateStringAsIsoDateString = (dateString) => {
  var splitDate = dateString.split('/');
  if (splitDate.length == 3) {
    let year = splitDate[2].length == 2 ? "20" + splitDate[2] : splitDate[2];
    let month = splitDate[1].length == 1 ? "0" + splitDate[1] : splitDate[1];
    let day = splitDate[0].length == 1 ? "0" + splitDate[0] : splitDate[0];
    return year + "-" + month + "-" + day;
  }
  return null;
}

// Convert a date string in the format DD/MM/YYYY into a Date object
export const getCalendarDateStringAsDate = (dateString) => {
  if (dateString && dateString != "null") {
    let day = parseInt(dateString.substring(0,2));
    let month = parseInt(dateString.substring(3,5));
    let year = parseInt(dateString.substring(6,10));
    return new Date(year, (month -1), day);
  }
  return null;
}

// Convert a Date object into a date string in the format YYYY-MM-DD
export const getApiDateFormat = (date) => {
  if (date) {
    const selectedMonth = ((date.getMonth() + 1) > 9) ? ("-" + (date.getMonth() + 1)) : ("-0" + (date.getMonth() + 1));
    const selectedDay = (date.getDate() > 9) ? ("-" + date.getDate()) : ("-0" + date.getDate());
    return date.getFullYear() + selectedMonth + selectedDay;
  }
}

// Convert a Date object into a date string in the format DD/MM/YYYY
export const getUkCalendarDateStringFromDate = (date) => {
  if (date) {
    const selectedMonth = ((date.getMonth() + 1) > 9) ? ("" + (date.getMonth() + 1)) : ("0" + (date.getMonth() + 1));
    const selectedDay = (date.getDate() > 9) ? ("" + date.getDate()) : ("0" + date.getDate());
    return selectedDay + "/" + selectedMonth + "/" + date.getFullYear();
  }
}

// Convert a Date object into a time string in the format HH:mm
export const getTimeStringFromDate = (date) => {
  if (date) {
    const selectedHours = (date.getHours() > 9) ? ("" + date.getHours()) : ("0" + date.getHours());
    const selectedMinutes = (date.getMinutes() > 9) ? ("" + date.getMinutes()) : ("0" + date.getMinutes());
    return selectedHours + ":" + selectedMinutes;
  }
}
  
  export const getDateRows = (monthIndex, year) => {
    const { days } = getMonthStats(monthIndex, year);
    const rows = getEmptyRows();
    const startIndex = new Date(year, monthIndex, 1).getDay();
    Array.from({ length: days }).forEach((_, i) => {
      const index = startIndex + i;
      rows[index] = i + 1;
    });
    const filled = rows.map(i => (Array.isArray(i) ? undefined : i));
  
    return filled[35] ? filled : filled.slice(0, -7);
  };
  
  export const noop = () => {};
  
  export const uuid = (() => {
    let id = 1;
    return () => {
      return ++id;
    };
  })();

export const isToday = (date) => {
  const today = new Date();
  today.setHours(0,0,0,0);
  date.setHours(0,0,0,0);
  return (date.getTime() === today.getTime());
}

export const isYesterday = (date) => {
  const today = new Date();
  today.setHours(0,0,0,0);
  date.setDate(date.getDate() + 1);
  date.setHours(0,0,0,0);
  return (date.getTime() === today.getTime());
}


export const isDateInPast = (date) => {
  const today = new Date();
  today.setHours(0,0,0,0);
  date.setHours(0,0,0,0);
  return (date.getTime() < today.getTime());
}

export const isDateInFuture = (date) => {
  const today = new Date();
  today.setHours(0,0,0,0);
  date.setHours(0,0,0,0);
  return (date.getTime() > today.getTime());
}

export const isDateWithinFuturePeriod = (date, periodInDays) => {
  const today = new Date();
  today.setDate(today.getDate() + periodInDays);
  today.setHours(0,0,0,0);
  date.setHours(0,0,0,0);
  return (date.getTime() <= today.getTime());
}

export const isDateWithinPastPeriod = (date, periodInDays) => {
  const today = new Date();
  today.setDate(today.getDate() - periodInDays);
  today.setHours(0,0,0,0);
  date.setHours(0,0,0,0);
  return (date.getTime() >= today.getTime());
}

export const getDaysDifference = (start, end) => {
  start.setHours(0,0,0,0);
  end.setHours(0,0,0,0);
  
  if (start.getTime() > end.getTime()) {
    return (Math.round((start.getTime() - end.getTime()) / (1000 * 60 * 60 * 24)));
  } else if (end.getTime() > start.getTime()) {
    return (Math.round((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)));
  } else{
    return 0;
  }
}

export const dateDescriptionStringAddExtraDescriptor = (dateDescriptionString, insertPastDescriptor) => {
  if (dateDescriptionString === 'Today' || dateDescriptionString === 'Yesterday' || dateDescriptionString === 'Tomorrow') {
    return dateDescriptionString;
  }
  else if (dateDescriptionString.substring(0,1) === "-") {
    //future date
    return " in " + dateDescriptionString.substring(1)
  }
  else if (insertPastDescriptor) {
    //past date
    return dateDescriptionString + ' ago';
  }
  else {
    return dateDescriptionString;
  }
}

export const getTimeClearedDate = (date) => {
  if (!date) {
    date = new Date();
  }
  date.setHours(0,0,0,0);
  return date;
}

const YEAR_ON_YEAR = -1;
const THIS_YEAR = -2
export const getStartDateFromDateRange = (dateRange) => {
  let startDate;
  if (dateRange == YEAR_ON_YEAR) {
      startDate = new Date(new Date().getFullYear(), 0, 1);
      startDate.setFullYear(startDate.getFullYear() - 4);
  } else if (dateRange == THIS_YEAR) {
      startDate = new Date(new Date().getFullYear(), 0, 1);
  } else {
      startDate = new Date();
      startDate.setDate(startDate.getDate() - dateRange);
  }
  return startDate;
}